/**
 * Budget Progress Bar Component
 *
 * Displays execution progress as a stacked bar with percentage label
 * Shows proportion of budget executed vs approved
 */

import { cn } from "@/lib/class-control";

interface BudgetProgressBarProps {
  /** Execution percentage (0-100) */
  percentage: number;
}

export function BudgetProgressBar({ percentage }: BudgetProgressBarProps) {
  // Flag for over budget
  const isOverBudget = percentage > 100;

  // Cap at 100% for visual purposes so it doesn't break out of the container
  // Only for the UI bar width, not the label
  const barWidth = Math.min(100, percentage);

  return (
    <div className="flex flex-col gap-[8px] w-full">
      {/* Progress bar container */}
      <div
        className={cn(
          "relative w-full h-[9px] rounded-[10px] overflow-visible",
          isOverBudget ? "bg-[#3D2626]" : "bg-[#D9FFEE]"
        )}
      >
        {/* Filled portion */}
        <div
          className={cn(
            "absolute left-0 top-0 h-full rounded-[10px] transition-all duration-300",
            isOverBudget ? "bg-[#F1745B]" : "bg-[#13D480]"
          )}
          style={{ width: `${barWidth}%` }}
        />
      </div>

      {/* Label row */}
      <div className="flex justify-between items-center text-[12px] font-normal text-white w-full">
        <p className="text-[#888888]">Percentual executado</p>
        <p className="text-white font-semibold">{percentage}%</p>
      </div>
    </div>
  );
}
